export class RogueAccessPoint {
    public storeNumber: string;
    public mac: string;
    public ssid: string;
    public rssi: number;
    public channel: string;
}